import { Col, Row } from "reactstrap"
import styles from "./Notifications.module.scss"
import Divider from "../../../../components/common/Divider/Divider"
import Toggle from "../../../../components/common/Toggle/Toggle"
import PrimaryButton from "../../../../components/common/PrimaryButton/PrimaryButton"

const Notifications = () => {
  return (
    <div>
      <Row noGutters>
        <Col xs="12" sm='12' md='12' lg='6' xl='6'>
          <div className={`shadow ${styles.header}`}>Allow system notifications to allow Maelano to send push messages.</div>
        </Col>
      </Row>

      <div className={styles["wrapper"]}>
        <div className={`${styles["notifications"]} shadow p-3`}>
          <div className="fw-medium">Notifications</div>
          <div className={`${styles["text-sm"]} text-muted`}>Choose which type of notifications you'd like to receive</div>
          <Divider />
          <div className="d-flex align-items-center justify-content-between my-3">
            <div>All</div>
            <div>
              <Toggle />
            </div>
          </div>

          <div className="ms-3">
            <div className="d-flex align-items-center justify-content-between my-3">
              <div>Promotions</div>
              <div>
                <Toggle />
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between my-3">
              <div>Discounts/Deals</div>
              <div>
                <Toggle />
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between my-3">
              <div>Shopping Cart Alert</div>
              <div>
                <Toggle />
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between my-3">
              <div>Order Updates</div>
              <div>
                <Toggle />
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between my-3">
              <div>Community</div>
              <div>
                <Toggle />
              </div>
            </div>
            <div className="ms-3">
              <div className="d-flex align-items-center justify-content-between my-3">
                <div>React</div>
                <div>
                  <Toggle />
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between my-3">
                <div>Reply</div>
                <div>
                  <Toggle />
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between my-3">
                <div>Answer</div>
                <div>
                  <Toggle />
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between my-3">
                <div>System notification</div>
                <div>
                  <Toggle />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`${styles["communication-channels"]} shadow p-3`}>
          <div className="fw-medium">Communication Channels</div>
          <div className={`${styles["text-sm"]} text-muted`}>Choose how you'd like to receive updates, promotions, and important notifications</div>

          <Divider />

          <div className="d-flex align-items-center justify-content-between my-3">
            <div>Email</div>
            <div>
              <Toggle />
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between my-3">
            <div>SMS</div>
            <div>
              <Toggle />
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between my-3">
            <div>Push Notifications</div>
            <div>
              <Toggle />
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between my-3">
            <div>Phone Calls</div>
            <div>
              <Toggle />
            </div>
          </div>
        </div>

        <div className={`${styles["subscription"]} shadow p-3`}>
          <div className="fw-medium">Subscription Options</div>
          <div className={`${styles["text-sm"]} text-muted`}>Select the types of content you'd like to receive from us.</div>

          <Divider />

          <ul>
            <li className="my-3">
              <div className="d-flex align-items-center justify-content-between">
                <div>Newsletter Subscription:</div>
                <div>
                  <Toggle />
                </div>
              </div>
              <div className={`${styles["text-sm"]} text-muted`}>Receive our latest news, offers, and updates</div>
            </li>
            <li className="my-3">
              <div className="d-flex align-items-center justify-content-between">
                <div>Order Updates</div>
                <div>
                  <Toggle />
                </div>
              </div>
              <div className={`${styles["text-sm"]} text-muted`}>Get real-time updates on your orders</div>
            </li>
            <li className="my-3">
              <div className="d-flex align-items-center justify-content-between">
                <div>Promotional Offers</div>
                <div>
                  <Toggle />
                </div>
              </div>
              <div className={`${styles["text-sm"]} text-muted`}>Be the first to know about special discounts and deals</div>
            </li>
            <li className="my-3">
              <div className="d-flex align-items-center justify-content-between">
                <div>Product Recommendations:</div>
                <div>
                  <Toggle />
                </div>
              </div>
              <div className={`${styles["text-sm"]} text-muted`}>Get personalized product suggestions based on your preferences</div>
            </li>
          </ul>
        </div>
        <div className={`${styles["manage"]} shadow p-3`}>
          <div className="fw-medium">Manage Preferences</div>
          <div className={`${styles["text-sm"]} text-muted`}>Manage your contact details and preferences at any time.</div>

          <Divider />

          <div>Update contact details</div>
          <div>
            <button className={`${styles["text-sm"]} ${styles.button}`}>Update Contact Detail</button>
          </div>
          <div className="mt-3">Unsubscribe</div>
          <div>
            <button className={`${styles["text-sm"]} ${styles.button}`}>Unsubscribe</button>
          </div>
        </div>

        <div className={`${styles["communication-channels-updates"]}`}>
          <div className="shadow p-3">
            
          <div className="fw-medium">Communication Channels</div>
          <div className={`${styles["text-sm"]} text-muted`}>Choose how often you want to hear from us</div>

          <Divider />

          <div className="d-flex align-items-center justify-content-between my-3">
            <div>Instant</div> <input type="radio" name="communication-channels-updates" className={styles.input} />
          </div>
          <div className="d-flex align-items-center justify-content-between my-3">
            <div>Daily</div> <input type="radio" name="communication-channels-updates" className={styles.input} />
          </div>
          <div className="d-flex align-items-center justify-content-between my-3">
            <div>Weekly</div> <input type="radio" name="communication-channels-updates" className={styles.input} />
          </div>
          <div className="d-flex align-items-center justify-content-between mt-3">
            <div>Monthly</div> <input type="radio" name="communication-channels-updates" className={styles.input} />
          </div>
          </div>
        </div>

        <div className={`${styles["submit"]} d-flex align-items-end justify-content-end`}>
          <div className="">
            <PrimaryButton name={"Submit Request"} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Notifications
